/** Formato local chileno. Todos los montos son CLP netos salvo que se indique. */

const clp = new Intl.NumberFormat('es-CL', {
  style: 'currency',
  currency: 'CLP',
  maximumFractionDigits: 0,
})

/*
 * El `replace` quita los espacios que Intl mete entre el símbolo y la cifra.
 * En una tabla densa de precios ese espacio rompe la alineación de la columna
 * y hace que dos montos del mismo largo se lean como distintos.
 */
export function money(n: number): string {
  return clp.format(Math.round(n)).replace(/\s/g, '')
}

export function num(n: number, decimales = 0): string {
  return new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  }).format(n)
}

export function kg(n: number): string {
  return `${num(n, n < 10 ? 1 : 0)} kg`
}

export function pct(fraccion: number, decimales = 1): string {
  return `${num(fraccion * 100, decimales).replace(/,0$/, '')}%`
}

export function fecha(iso: string): string {
  return new Date(iso).toLocaleDateString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/**
 * Una fecha SIN HORA: se formatea tal cual viene, sin pasar por la zona local.
 *
 * HACE FALTA PORQUE `new Date(iso)` INTERPRETA Y CONVIERTE. Las columnas `DATE`
 * de la base —el rango de entregas de una liquidación, por ejemplo— viajan como
 * `2026-09-01T00:00:00.000Z`, y `toLocaleDateString` en Chile (UTC−4) las
 * retrocede a las 20:00 del 31 de agosto: la pantalla mostraba una entrega un
 * día antes de la real.
 *
 * No es un detalle cosmético. Sobre un plazo de pago, un día de diferencia es la
 * llamada de un proveedor preguntando por qué la fecha no coincide con su guía.
 *
 * Se usa SOLO con valores que representan un día del calendario y no un
 * instante. Para un instante —`creadoEn`, `enviadoEn`— la conversión a hora
 * local es correcta y hay que usar `fecha`.
 */
export function fechaSola(iso: string): string {
  const [anio, mes, dia] = iso.slice(0, 10).split('-')
  return `${dia}-${mes}-${anio}`
}

/**
 * Fecha con el mes escrito.
 *
 * Se usa donde la fecha es un compromiso y no un dato de tabla —vencimiento de
 * la factura, fecha comprometida de entrega—: "12/03/2026" se lee de reojo y se
 * confunde con el 3 de diciembre; "12 de marzo de 2026" no.
 */
export function fechaLarga(iso: string): string {
  return new Date(iso).toLocaleDateString('es-CL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

/** Los estados del dominio llevan guion bajo; a la vista van con espacio. */
export function etiquetaEstado(estado: string): string {
  return estado.replace(/_/g, ' ')
}
